import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.less';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const enableStrictMode = process.env.NODE_ENV === 'development' && false;

root.render(
  enableStrictMode ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
